const { CrudModel } = require('./crud');

export class BankingAccountModel extends CrudModel {
	constructor() {
		super('admin/banking_account', []);
	}

	getBankingAccounts(): Promise<any[]> {
		return this.executeAction(null, "listBankingAccounts");
	}
}

export default new BankingAccountModel();
